import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches city suggestions for the location filter. The backend returns real
 * index values from the company database (e.g. "Frankfurt a. Main") together
 * with the federal state and company count, so picking a suggestion guarantees
 * an exact match in the HR search.
 *
 * @param {string} query - Partial city name (min. 2 characters)
 * @returns {Promise<Array<{city: string, state: string|null, count: number}>>}
 */
export const fetchCitySuggestions = async (query) => {
	const response = await fetcher(`/api/v1/search/autocomplete/cities?q=${encodeURIComponent(query)}`);
	return response?.data || [];
};
